import { computed, inject, Signal } from '@angular/core';
import { Product } from 'product-shared';
import { Promotion } from 'promotion-shared';
import { TranslateService } from 'translate';

export class ProductBoxBase {
  protected translateService = inject(TranslateService);
  public product: Signal<Product>;
  public promotion: Signal<Promotion>;
  public hasDiscountedCost = computed(
    () => this.product()?.discountedPrice(this.promotion()?.discountAmount) < this.product()?.monthly_cost
  );
  public promotionBannerText = computed(() => {
    return (
      this.product()?.promotion_banner_text ||
      this.promotion().title ||
      `${Promotion.discountPercentage(
        Number(this.product()?.monthly_cost),
        this.promotion().discountAmount
      )}% ${this.translateService.getTranslation(['discount'])}`
    );
  });
  public discountedPrice = computed(() => this.product()?.discountedPrice(this.promotion()?.discountAmount));
  public activationFee = computed(() => {
    if (typeof this.promotion()?.activationFeeDiscount !== 'undefined') {
      return this.product()?.activation_fee - this.promotion().activationFeeDiscount;
    }

    return this.product()?.activation_fee;
  });
}
